import {forwardRef} from 'react';
import {BleskIcon} from '../types';
import {BaseIcon} from './BaseIcon';

export const Pause: BleskIcon = forwardRef(function Pause(props, ref) {
  return (
    <BaseIcon {...props} ref={ref}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 18V18C15.172 18 14.5 17.328 14.5 16.5V7.5C14.5 6.672 15.172 6 16 6V6C16.828 6 17.5 6.672 17.5 7.5V16.5C17.5 17.328 16.828 18 16 18Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 18V18C7.172 18 6.5 17.328 6.5 16.5V7.5C6.5 6.672 7.172 6 8 6V6C8.828 6 9.5 6.672 9.5 7.5V16.5C9.5 17.328 8.828 18 8 18Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
});
